/**
 * Athlete notifications from the app.
 *
 * Posts to /api/portal/notify with the staff PocketBase token. The server
 * checks the client belongs to the caller's agency and sends email plus push
 * according to the athlete's preferences. The shared notification secret
 * never reaches the browser.
 */

import { pb } from '../lib/pocketbase'

export type PortalNotifyType = 'deal_update' | 'message' | 'document_shared' | 'action_item'

export interface PortalNotifyOutcome {
  sent: boolean
  reason?: string
  email?: { sent: boolean; to?: string; error?: string }
  push?: { sent: number; failed: number; deactivated: number; error?: string }
}

export async function notifyAthlete(
  type: PortalNotifyType,
  clientId: string,
  metadata: Record<string, unknown>,
): Promise<PortalNotifyOutcome> {
  const res = await fetch('/api/portal/notify', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${pb.authStore.token}`,
    },
    body: JSON.stringify({ type, client_id: clientId, metadata }),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(data.error || `Could not notify the athlete (${res.status})`)
  }
  return data as PortalNotifyOutcome
}
